import React from 'react';

import createIcon from '../../../../icons/createIcon';

export default createIcon('12 12 24 24', <path d="M22 33l14-14-2.82-2.82L22 27.34l-6.18-6.16L13 24z" />);
